import './App.css';
import {Routes,Route} from 'react-router-dom'
import Sidebar from './components/Sidebar';
import { useSelector } from 'react-redux'
import { selectToggle} from './redux/features/sidebarSlice'
import classes from './styles/Products.module.scss'
import { ProtectedRoute } from './components/ProtectedRoute';
import { Suspense, lazy } from "react";
import Products from './components/ProductsLayout';
import ProductsLayout from './components/ProductsLayout';
import Gender from './pages/Gender';
import Category from './pages/Category';
import NotFound from './pages/NotFound';
import Loader from './components/Loader';


const Home = lazy(() => import('./pages/Home'));
const Cart = lazy(() => import('./pages/Cart'));
const ProductDetails = lazy(() => import('./pages/Product-details'));
const Shipping = lazy(() => import('./pages/Shipping'));
const Order = lazy(() => import('./pages/Order'));
const ProductUpload = lazy(() => import('./pages/admin/Product-upload'));
const Dashboard = lazy(() => import('./pages/admin/Dashboard'));
const AllProducts = lazy(() => import('./pages/admin/AllProducts'));
const Orders = lazy(() => import('./pages/admin/Orders'));
const Login = lazy(() => import('./pages/admin/login'));
const Users = lazy(() => import('./pages/admin/Users'));
const Emails = lazy(() => import('./pages/admin/Emails'));

function App() {
  const open=useSelector(selectToggle)
  return (
    <div className="App">
        <div className={open ? classes.bg : ''}><Sidebar /></div>
       <Routes>
        <Route path="/" element={<Suspense fallback={<Loader></Loader>}>
            <Home />
          </Suspense>}/>

        
        <Route path="/products" element={<ProductsLayout />}>

          <Route
            path=":gender"
            element={
              <Suspense fallback={<Loader></Loader>}>
                <Gender />
              </Suspense>
            }
          >
            <Route path=":category" element={<Category />} />
            
          </Route>

      
          {/* <Route
            path=":gender/:id"
            element={
              <Suspense fallback={<>...</>}>
                <ProductDetails />
              </Suspense>
            }
          />

          <Route
            path=":gender/:category/:id"
            element={
              <Suspense fallback={<>...</>}>
                <ProductDetails />
              </Suspense>
            }
          /> */}
          

        </Route>


        <Route
          path="/product/:id"
          element={
            <Suspense fallback={<Loader></Loader>}>
              <ProductDetails />
            </Suspense>
          }
        />

        {/* <Route path="/children" element={<Children />} /> */}
        <Route path="/cart" element={<Suspense fallback={<Loader></Loader>}>
            <Cart />
          </Suspense>} />
        
        {/* <Route path="/login" element={<Auth />} /> */}
        <Route path="/shipping" element={<Suspense fallback={<Loader></Loader>}>
            <Shipping />
          </Suspense>} />
        {/* <Route path="/payment" element={<Payment />} /> */}
        <Route path="/order" element={<Suspense fallback={<Loader></Loader>}>
            <Order />
          </Suspense>} />
        
        {/* Protected routes are meant to be visited only by admin */}
        <Route path="/admin/product-upload" element={<ProtectedRoute><Suspense fallback={<Loader></Loader>}>
            <ProductUpload />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/dashboard" element={<ProtectedRoute><Suspense fallback={<Loader></Loader>}>
            <Dashboard />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/products" element={<ProtectedRoute><Suspense fallback={<Loader></Loader>}>
            <AllProducts />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/product/update/:id" element={<ProtectedRoute><Suspense fallback={<Loader></Loader>}>
            <ProductUpload />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/orders" element={<ProtectedRoute><Suspense fallback={<Loader></Loader>}>
            <Orders />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/login" element={<Suspense fallback={<Loader></Loader>}>
            <Login />
          </Suspense>} />
        <Route path="/admin/users" element={<ProtectedRoute><Suspense fallback={<Loader></Loader>}>
            <Users />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/emails" element={<ProtectedRoute><Suspense fallback={<Loader></Loader>}>
            <Emails />
        </Suspense></ProtectedRoute>} />


        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
